import React from 'react';

function FormError(props) {
    const { 
        value = '', 
        labelClass = 'invalid-feedback',
        className = 'form-group'
    } = props;
    return (
        <div className={className}>
            {value && (
                <label className={labelClass} style={{display: 'block'}}>{value}</label>
            )}
        </div>
    );
}


export default FormError;
